'use client';
import { useEffect, useState } from 'react';

import { ModalHeader } from '@/components/molecules';

interface ModalWrapperProps {
	title: string;
	className?: string;
	onClose: () => void;
	children: React.ReactNode;
	closeOnOutsideClick?: boolean;
	overlayClassName?: string;
	showModalHeader?: boolean;
}

export const ModalWrapper = ({
	title,
	className,
	onClose,
	children,
	closeOnOutsideClick = true,
	overlayClassName,
	showModalHeader = true
}: ModalWrapperProps) => {
	const [isOpen, setIsOpen] = useState(true);

	// Controls page scrolling by adding or removing a class on the body when the modal is open.
	useEffect(() => {
		if (isOpen) {
			document.body.classList.add('modal-open');
		} else {
			document.body.classList.remove('modal-open');
		}

		return () => {
			document.body.classList.remove('modal-open');
		};
	}, [isOpen]);

	const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (closeOnOutsideClick && e.target === e.currentTarget) {
			setIsOpen(false);
			e.preventDefault();
			e.stopPropagation();
			onClose();
		}
	};

	const handleClose = () => {
		setIsOpen(false);
		onClose();
	};

	return (
		<div
			className={`fixed inset-0 z-50 flex items-center justify-center bg-black/50 ${overlayClassName}`}
			onMouseDown={handleBackdropClick}
			role="presentation"
		>
			<div
				className={`scrollbar-thin max-h-[450px] overflow-auto sm:max-h-[600px] mx-5 flex h-auto w-full max-w-96 flex-col rounded-lg bg-white p-6 shadow-xl ${className}`}
				onClick={(e) => e.stopPropagation()}
				role="presentation"
			>
				{!!showModalHeader && <ModalHeader title={title} onClose={handleClose} />}
				<div>{children}</div>
			</div>
		</div>
	);
};
